import { styled } from '@mui/system';
import { List } from '@mui/material';

export const StyledLogsList = styled(List, {
  shouldForwardProp: prop => prop !== 'loading'
})(({ loading }) => ({
  ...(loading && {
    '& > div': {
      filter: 'blur(5px)',
      animation: 'blink 1s alternate infinite linear'
    }
  }),
  '@keyframes blink': {
    from: {
      opacity: 0.5
    },
    to: {
      opacity: 1
    }
  }
}));
